module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-ac209be0.eot";